import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row, Select } from "antd";
import AppInput from "../../../../components/AppInput";
import moment from "moment";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { useParams } from "react-router-dom";
import { fuelTypeOptions } from "../../../../Data/data";

const { Option } = Select;

function EditBunkerDetailsCom() {
  const [subTankList, setSubTankList] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const { bunker_id } = useParams();

  const [form, setForm] = useState({
    bunkerDate: moment().format("YYYY-MM-DD"),
    bdnReferenceNo: "",
    bunkeringLocation: "",
    supplierName: "",
    chartererOrOwner: "",
    bargeNameAndImo: "",
    grade: "",
    density: "",
    sulphur: "",
    // tanks: "",
    // quantity: "",
    chiefEngSign: "",
    totalquantity: "",
    tanks: [{ tankId: null, quantity: "" }],
  });

  const LIST_SUB_TANKS_API = async () => {
    const FORM_DATA = new FormData();
    const staff_Details = JSON.parse(localStorage.getItem("user_data"));
    FORM_DATA.append("ship_id", staff_Details?.data?.ship_details?.ship_id);
    try {
      post(ApiURL?.bunker_report_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setSubTankList(res?.tanks);

        }
      });
    } catch (error) {
      console.error("Error fetching Sub Tanks list:", error);
    }
  };

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    VIEW_BUNKER_DETAILS();
    LIST_SUB_TANKS_API();
  }, []);

  const VIEW_BUNKER_DETAILS = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("sulphur_record_id ", atob(bunker_id));
      post(ApiURL.view_bunker_details_bd_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const data = res?.sulphur_record_one;
          setForm({
            bunkerDate: data?.bunker_date || moment().format("YYYY-MM-DD"),
            bdnReferenceNo: data?.bdn_reference_no || "",
            bunkeringLocation: data?.bunkering_location || "",
            supplierName: data?.supplier_name || "",
            chartererOrOwner: data?.charterer_or_owner || "",
            bargeNameAndImo: data?.barge_name_and_imo || "",
            grade: data?.grade || "",
            density: data?.density || "",
            sulphur: data?.sulphur || "",
            tanks: data?.tanks || "",
            quantity: data?.quantity || "",
            chiefEngSign: data?.chief_eng_sign || "",
            totalquantity: data?.totalquantity || "",
            tanks: Array.isArray(data?.tanks)
              ? data.tanks
              : [{ tankId: null, quantity: "" }],
          });
          setSubmitStatus(data?.submit_status);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
    }
  };

  return (
    <>
      <div className="white-container">
        <h3>View Bunker Record</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              type="date"
              label="Bunker Date"
              value={form.bunkerDate}
              // onChange={(e) => handleChange("bunkerDate", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="BDN Reference No."
              value={form.bdnReferenceNo}
              // onChange={(e) => handleChange("bdnReferenceNo", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Bunkering Location"
              value={form.bunkeringLocation}
              // onChange={(e) =>
              //   handleChange("bunkeringLocation", e.target.value)
              // }
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Name of the Supplier"
              value={form.supplierName}
              // onChange={(e) => handleChange("supplierName", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Bunker Supplied by Charterer/Owner"
              value={form.chartererOrOwner}
              // onChange={(e) => handleChange("chartererOrOwner", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Barge Name details / IMO No."
              value={form.bargeNameAndImo}
              // onChange={(e) => handleChange("bargeNameAndImo", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <label className="form-label">Grade</label>

            <Select
              disabled={submitStatus}
              value={form.grade}
              style={{ width: "100%" }}
              placeholder="Select Fuel Grade"
              options={fuelTypeOptions}
              // onChange={(value) => handleChange("grade", value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Density at 15°C (Kg/m³)"
              value={form.density}
              // onChange={(e) => handleChange("density", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Sulphur (%m/m)"
              value={form.sulphur}
              // onChange={(e) => handleChange("sulphur", e.target.value)}
            />
          </div>
          {/* <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Quantity (MT)"
              value={form.quantity}
              // onChange={(e) => handleChange("quantity", e.target.value)}
            />
          </div> */}
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label=" Total Quantity (MT)"
              value={form.totalquantity}
              // onChange={(e) => handleChange("totalquantity", e.target.value)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              disabled={submitStatus}
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
              // onChange={(e) => handleChange("chiefEngSign", e.target.value)}
            />
          </div>
          {/* <div className="col-6">
            <label className="form-label">Tank No.</label>
            <Select
              disabled={submitStatus}
              value={form.tanks}
              // onChange={(value) => handleChange("tanks", value)}
              placeholder="Select Tank"
              style={{ width: "100%" }}
            >
              {subTankList?.map((tank) => (
                <Option key={tank.id} value={tank.id}>
                  {`${tank.id} - ${tank.category_name} (${tank.fuel_type || "No fuel"})`}
                </Option>
              ))}
            </Select>
          </div> */}
        </div>

        {/* Tanks Section */}
        <div className="mt-3 input-box p-3">
          {form.tanks.map((tank, index) => (
            <Row gutter={16} key={index} style={{ marginBottom: 16 }}>
              <Col span={12}>
                <label className="form-label">Tank No.</label>
                <Select
                  disabled={submitStatus}
                  value={tank.tankId}
                  // onChange={(value) => handleTankChange(index, value)}
                  placeholder="Select Tank"
                  style={{ width: "100%" }}
                >
                  {subTankList?.map((t) => (
                    <Option key={t.id} value={t.id}>
                      {`${t.id} - ${t.category_name} (${
                        t.fuel_type || "No fuel"
                      })`}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                <label className="form-label">Quantity (MT)</label>
                <Input
                  disabled={submitStatus}
                  type="number"
                  value={tank.quantity}
                  // onChange={(e) => handleQuantityChange(index, e.target.value)}
                  placeholder="Enter Quantity"
                />
              </Col>
            </Row>
          ))}

          {/* <Button
            type="dashed"
            onClick={handleAddTank}
          >
            + Add Another Tank
          </Button> */}
        </div>
      </div>
    </>
  );
}

export default EditBunkerDetailsCom;
